/**
 * <strong>Purpose:</strong> <br>
 * Adds aria-labelledBy attribute to the widget.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * The widget should have focusNode, textNode, descriptionNode and shortcutKeyNode <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/TextMixin} <br>
 *
 * @module mw-form/mixins/MenuItemAriaLabelledByMixin
 *
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/ShortcutMixin"
], function (declare, TextMixin, DescriptionMixin, ShortcutMixin) {

    var MenuItemAriaLabelledByMixin = declare(null, {

        postCreate: function () {
            this.inherited(arguments);

            var textNodeId = this.id + "_textNodeId";
            var descriptionNodeId = this.id + "_descriptionNodeId";
            var shortcutKeyNodeId = this.id + "_shortcutKeyNodeId";
            var textNode = this.textNode.querySelector(".mwTextLine");

            if (!textNode) {
                textNode = this.textNode;
            }
            textNode.setAttribute("id", textNodeId);

            // TextFieldMenuItem does not have a descriptionNode. So, have a check below to make sure that the node
            // exists before trying to set the "id".
            if (this.descriptionNode) {
                this.descriptionNode.setAttribute("id", descriptionNodeId);
            }

            this.shortcutKeyNode.setAttribute("id", shortcutKeyNodeId);

            // Even if the descriptionNode does not exist for TextFieldMenuItem, having the descriptionNode id here
            // does not have any consequences. Hence, it is okay to leave the below line as is, instead of writing
            // extra code for TextFieldMenuItem usecase.
            this.focusNode.setAttribute("aria-labelledby", textNodeId + " " + descriptionNodeId + " " + shortcutKeyNodeId);
        }
    });

    MenuItemAriaLabelledByMixin._dependencies = [
        {mixin: TextMixin, orderDependent: false},
        {mixin: DescriptionMixin, orderDependent: false},
        {mixin: ShortcutMixin, orderDependent: false}
    ];
    return MenuItemAriaLabelledByMixin;
});
